// extracted by mini-css-extract-plugin
export default {"root":"aA9y4oEEpD6DlXu66VoQ","left":"NHR8nDAUBhHSt8OrBJLu","right":"I8h8tUcA3HjflOC7MJqQ","logo":"taIp2vkSIllhWCeIV8Ug","name":"fH35x2ssy3zCrNzwDLiZ"};